export declare const ToEllipsis: any;
export default ToEllipsis;
export * from './src/ellipsis';
